import ImageWithLoading from "@/components/image/image-with-loading";
import { textVariants } from "@/utils/text-variants";
import { memo } from "react";

interface SwapPickItemProps {
  imageUrl: string;
  name: string;
  description: string;
}

export const SwapPickItem = memo(function SwapPickItem({
  imageUrl,
  name,
  description,
}: SwapPickItemProps) {
  return (
    <div className="flex max-w-27 flex-col items-center gap-3">
      <ImageWithLoading
        src={imageUrl}
        alt={name}
        classNames={{
          container: "aspect-square w-full h-auto rounded-full overflow-hidden",
          image: "object-cover",
        }}
      />
      <div className={textVariants.footnote}>
        <h3 className="text-center font-bold">{name}</h3>
        <p className="text-center font-normal text-gray-600">{description}</p>
      </div>
    </div>
  );
});
